import { useQuery } from '@tanstack/react-query';
import backend from '../../services/backend';

export const AUDIT_SAMPLE_SIZE = 20;

/**
 * One sample per `round`. Never refetched in the background while mounted: a refetch would replace the items under
 * the reviewer. `gcTime: 0` drops the sample on unmount, so a return to the page draws a fresh sample without the
 * findings labelled since, instead of the cached one from position 0.
 * "Load more" bumps the round, which fetches a new sample.
 */
export const auditSampleQueryOptions = (round: number, checkId = '') => ({
  queryKey: ['getSupervisorAuditSample', round, checkId],
  queryFn: async () => (await backend.getSupervisorAuditSample(AUDIT_SAMPLE_SIZE, checkId || undefined)).data,
  staleTime: Infinity,
  gcTime: 0,
  refetchOnWindowFocus: false,
  retry: false,
});

export function useAuditSample(round: number, checkId = '') {
  return useQuery(auditSampleQueryOptions(round, checkId));
}
